import axios from './axiosService';

export default {
  async openMetabase() {
    const {url} = await this.getAuthorizationURL();
    let link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  getAuthorizationURL() {
    return axios.get(`/api/metabase/auth`)
      .then(response => response.data);
  },
  getUsersForTeam() {
    return axios.get(`/api/metabase/users`)
      .then(response => response.data);
  },
  getGroupsForTeam() {
    return axios.get(`/api/metabase/groups`)
      .then(response => response.data);
  },
  createUser(form) {
    return form.post(`/api/metabase/users`)
      .then(response => response.data);
  },
  updateUser(userID, form) {
    return form.put(`/api/metabase/users/${userID}`)
      .then(response => response.data);
  },
}
